export default {
  /* Method : GET */
  getUserList: "/api/v1/users/",
  /* Method : GET */
  postUser: "/api/v1/users/",
  autocomplete: "/api/v1/users/autocomplete/",
  postImportUser: "/api/v1/users/import/",
  /**
   * Retrieve full details of a user
   * @param {String} orgSlug - Organization Slug.
   */
  downloadUserImportSample: orgSlug =>
    `api/v1/users/import/sample/?organization=${orgSlug}`,
  /**
   * Retrieve full details of a user
   * @param {String} userId - The id of user.
   */
  getUserDetail: userId => `/api/v1/users/${userId}/`,
  deleteUser: userId => `/api/v1/users/${userId}/`,
  /**
   * Update details of a user
   * Method: PUT / PATCH
   * @param {String} userId - The id of user.
   */
  updateUser: userId => `/api/v1/users/${userId}/`,
  /**
   * Method - POST
   * Change the password of a user
   * payload - (old_password, password, repeat_password)
   * @param {String} userId - The id of user.
   */
  changePassword: userId => `/api/v1/users/${userId}/change-password/`
};
